import React, { useState } from 'react';
import { obrisiMerenje } from '../utils/merenja';
import { klasifikujPritisak, formatDatum } from '../utils/helpers';

export default function TabelaMerenja({ merenja, onObrisano }) {
  const [brisanje, setBrisanje] = useState(null);

  async function handleObrisi(id) {
    if (!window.confirm('Da li ste sigurni da želite da obrišete ovo merenje?')) return;
    setBrisanje(id);
    try {
      await obrisiMerenje(id);
      onObrisano && onObrisano();
    } catch {
      alert('Greška pri brisanju.');
    }
    setBrisanje(null);
  }

  if (!merenja || merenja.length === 0) {
    return (
      <div className="card records-card">
        <div className="records-header">
          <h3 className="records-title">📅 Istorija merenja</h3>
        </div>
        <div className="empty-state">
          <div className="empty-icon">📊</div>
          <h3>Nema merenja</h3>
          <p>Unesite prvo merenje da biste videli istoriju.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="card records-card">
      <div className="records-header">
        <h3 className="records-title">📅 Istorija merenja</h3>
        <span style={{ fontSize: '0.82rem', color: '#9c8278' }}>{merenja.length} unosa</span>
      </div>

      <div className="table-wrap">
        <table>
          <thead>
            <tr>
              <th>Datum i vreme</th>
              <th>Pritisak</th>
              <th>Puls</th>
              <th>Status</th>
              <th>Napomena</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {merenja.map(m => {
              const status = klasifikujPritisak(m.sistolni, m.dijastolni);
              return (
                <tr key={m.id}>
                  <td style={{ whiteSpace: 'nowrap', color: '#5c4a44', fontSize: '0.85rem' }}>
                    {formatDatum(m.datumVreme)}
                  </td>
                  <td>
                    <span className="pressure-display">
                      <span className="pressure-sys">{m.sistolni}</span>
                      <span className="pressure-sep">/</span>
                      <span className="pressure-dia">{m.dijastolni}</span>
                    </span>
                    <span style={{ fontSize: '0.75rem', color: '#9c8278', marginLeft: 4 }}>mmHg</span>
                  </td>
                  <td>
                    {m.puls ? (
                      <span style={{ fontWeight: 600 }}>{m.puls} <span style={{ fontSize: '0.75rem', color: '#9c8278' }}>bpm</span></span>
                    ) : (
                      <span style={{ color: '#ccc' }}>—</span>
                    )}
                  </td>
                  <td>
                    <span className={`status-badge ${status.klasa}`}>{status.label}</span>
                  </td>
                  <td style={{ fontSize: '0.83rem', color: '#9c8278', maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {m.napomena || <span style={{ color: '#e0d4d0' }}>—</span>}
                  </td>
                  <td>
                    <button
                      className="btn btn-danger-ghost btn-sm"
                      onClick={() => handleObrisi(m.id)}
                      disabled={brisanje === m.id}
                    >
                      {brisanje === m.id ? '...' : '🗑'}
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
